import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarLayout from '../common/SidebarLayout.js';
import AdminDashboard from './AdminDashboard.js';
import AdminUsers from './AdminUsers.js';
import AdminBranches from './AdminBranches.js';
import AdminReports from './AdminReports.js';
import AdminOrders from './AdminOrders.js';
import AdminWaiterReport from './AdminWaiterReport.js';
import ProductReports from './ProductReports.js';
import AdminBackup from './AdminBackup.js';

const menuItems = [
  { label: 'Dashboard', icon: '🎛️', path: '/admin' },
  { label: 'Branches', icon: '📍', path: '/admin/branches' },
  { label: 'Users', icon: '👥', path: '/admin/users' },
  { label: 'Reports', icon: '📊', path: '/admin/reports' },
  { label: 'Product Reports', icon: '🛍️', path: '/admin/products-reports' },
  { label: 'Orders', icon: '🎫', path: '/admin/orders' },
  { label: 'Waiter Report', icon: '🧑‍🍳', path: '/admin/waiter-report' },
  // { label: 'Backup', icon: '💾', path: '/admin/backup' }
];

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState('Dashboard');

  useEffect(() => {
    const match = menuItems.find((item) => item.path === location.pathname);
    setActiveMenu(match ? match.label : 'Dashboard');
  }, [location.pathname]);

  const handleMenuClick = (menuLabel) => {
    const menuItem = menuItems.find((item) => item.label === menuLabel);
    if (menuItem) {
      navigate(menuItem.path);
    }
  };

  const renderContent = () => {
    switch (activeMenu) {
      case 'Dashboard':
        return <AdminDashboard />;
      case 'Users':
        return <AdminUsers />;
      case 'Branches':
        return <AdminBranches />;
      case 'Reports':
        return <AdminReports />;
      case 'Orders':
        return <AdminOrders />;
      case 'Waiter Report':
        return <AdminWaiterReport />;
      case 'Product Reports':
        return <ProductReports />;
      // case 'Backup':
      //   return <AdminBackup />;
      default:
        return <AdminDashboard />;
    }
  };

  return (
    <SidebarLayout
      title="Admin Panel"
      subtitle="Manage system settings"
      menuItems={menuItems}
      activeItem={activeMenu}
      onMenuClick={handleMenuClick}
      userRole="Admin"
    >
      {renderContent()}
    </SidebarLayout>
  );
};

export default AdminLayout;